import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzInventory() {
    const source = axios.CancelToken.source();

    const [taxRates, setTaxRates] = useState<vp.RailzTaxRate[]>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchTaxRates = async (requestParams: vp.RailzTaxRatesRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzTaxRates(requestParams, source);
        setTaxRates(res.TaxRates);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setTaxRates(undefined);
    };

    return {
      taxRates,
      fetchTaxRates,
      reset,
    };
  };
});

export default initHook({});
